var m = require('mithril');
var prop = require('mithril/stream');
var session = require('../models/session');
var loaders = require('../../layout/components/loaders');
var header = require('../../layout/components/header');
var requestStatusHandler = require('../../layout/components/requestStatusHandler');
var RequestStatus = require('../../layout/enums/RequestStatus');
var modalForm = require('../../layout/components/modalForm');
var dragscroll = require('../../libs/dragscroll');
var buttonElement = require('../../components/button');
var addMemberModal = require('./addMemberModal');
var userModal = require('./addUserModal');
var groupModal = modalForm(require('../models/group'));
var groupPermissionModal = require('../../locations/components/editGroupPermissionsModal');
var dashboardPermissionModal = modalForm(require('../../dashboards/models/permission'));
var reportFolderPermissionModal = modalForm(require('../../reports/models/permission'));
var rowActionDropdown = require('../../components/rowActionDropdown');
const { setRoomClassTree, isLocationClass, isRoomClass } = require('../../maps/mapUtils');

var roomClassTreePromise = null;

function ensureRoomClassTreeLoaded() {
  if (!roomClassTreePromise) {
    roomClassTreePromise = loaders.requestWithLoader({
      loader: 'background',
      url: '/api/v1/roomclasstree',
      method: 'GET'
    })
    .then(function (tree) {
      setRoomClassTree(tree);
    })
    .catch(function () {});
  }
  return roomClassTreePromise;
}

// Natural sort helpers (number-aware, case-insensitive)
function tokenize(str) {
  const input = String(str || '');
  return input.split(/(\d+)/).map((s) => (isNaN(s) ? s.toLowerCase() : parseInt(s, 10)));
}
function naturalCompareStrings(a, b) {
  const ax = tokenize(a);
  const bx = tokenize(b);
  for (let i = 0; i < Math.max(ax.length, bx.length); i++) {
    const av = ax[i];
    const bv = bx[i];
    if (av === undefined) return -1;
    if (bv === undefined) return 1;
    if (typeof av === 'number' && typeof bv === 'number') {
      if (av !== bv) return av - bv;
    } else {
      const as = String(av);
      const bs = String(bv);
      if (as !== bs) return as.localeCompare(bs, undefined, { sensitivity: 'base' });
    }
  }
  return 0;
}

function renderMemberName(user, canLinkUser) {
  var name = user.name || '';
  if (!canLinkUser) return name;

  return m(m.route.Link, { href: '/user/' + user['@rid'].slice(1), class: 'blue' }, name);
}

function joinClass() {
  return Array.prototype.slice.call(arguments)
    .filter(Boolean)
    .join(' ');
}

function renderTableTitle(label, count) {
  return m('div.flex.items-center', [
    m('span', label),
    m('span.f7.fw6.ml2.pv1.ph2.br2.ba.b--mid-gray.near-white', {
      style: { fontSize: '0.75rem', lineHeight: '1' }
    }, count)
  ]);
}

function renderGroupDetailTable(options) {
  var columns = Array.isArray(options.columns) ? options.columns : [];
  var visibleColumns = options.skipFirstColumn ? columns.slice(1) : columns;
  var firstColumn = visibleColumns[0] || {};
  var headerColumns = visibleColumns.slice(1);
  var rows = Array.isArray(options.rows) ? options.rows : [];
  var colspan = Math.max(visibleColumns.length, 1);
  var hasColumnWidths = visibleColumns.some(function (column) { return column.width; });
  var firstColumnWidth = visibleColumns.length > 1 ? '24em' : null;

  return m('div.overflow-hidden', [
    m('div.dragscroll-container', [
      m('div.dragscroll', { oncreate: dragscroll }, [
        m('table.w-100.f4.mb4.mt2.pr4.pb3.narrow', {
          style: firstColumnWidth ? { tableLayout: 'fixed' } : null
        }, [
          hasColumnWidths || firstColumnWidth ?
            m('colgroup', visibleColumns.map(function (column, idx) {
              var width = idx === 0 ? firstColumnWidth : column.width;
              return width ? m('col', { style: { width: width } }) : m('col');
            }))
            : '',
          m('thead', [
            m('tr', [
              m('th.v-btm.pv1.bb.f1.fw5.tl.bw1.pr3', {
                class: joinClass(firstColumn.class, firstColumn.titleClass),
                style: firstColumnWidth ? { width: firstColumnWidth, maxWidth: firstColumnWidth, whiteSpace: 'nowrap' } : null
              }, [
                m('div.flex.justify-between.items-end', options.title)
              ]),
              headerColumns.map(function (column) {
                return m('th.tl.v-btm.bb.fw2.bw1.ph1', {
                  class: joinClass(column.class, column.headerClass)
                }, column.label);
              })
            ])
          ]),
          m('tbody', rows.length ?
            rows.map(function (row) {
              return m('tr', visibleColumns.map(function (column, idx) {
                return m('td.bb', {
                  class: joinClass(column.class, column.cellClass),
                  style: idx === 0 && firstColumnWidth ?
                    { width: firstColumnWidth, maxWidth: firstColumnWidth, whiteSpace: 'normal', overflowWrap: 'anywhere' }
                    :
                    null
                }, column.render ? column.render(row) : row[column.key]);
              }));
            })
            :
            [
              m('tr', [
                m('td.gray.pv2', { colspan: colspan }, options.emptyText || 'No records found.')
              ])
            ]
          )
        ])
      ])
    ])
  ]);
}

function memberActionItems(ctrl, user) {
  return user.isGroupAdmin ?
    [
      {
        label: 'Remove as Group Admin',
        icon: 'ion-ios-compose',
        onclick: function () { return ctrl.updateIsAdmingroup(user, false); }
      }
    ]
    :
    [
      {
        label: 'Set as Group Admin',
        icon: 'ion-ios-compose',
        onclick: function () { return ctrl.updateIsAdmingroup(user, true); }
      },
      {
        label: 'Remove User',
        icon: 'ion-ios-trash',
        class: 'red',
        onclick: function () { return ctrl.deleteUserFromGroup(user); }
      }
    ];
}

function renderMemberNameCell(ctrl, user) {
  return m('div.flex.items-center.justify-between', [
    m('span.mr3.truncate', { style: { minWidth: 0 } }, renderMemberName(user, ctrl.canEditAccessPermissions)),
    ctrl.isGroupAdmin ?
      m('span.flex-none', [
        m(rowActionDropdown, {
          buttonClass: 'dib mr3',
          items: memberActionItems(ctrl, user)
        })
      ])
      :
      ''
  ]);
}

function renderAdminIcon(user) {
  return user.isGroupAdmin ?
    m('i.f2.ml2.ion-android-checkbox-outline.green')
    :
    m('i.f2.ml2.ion-android-checkbox-outline-blank.gray');
}

function memberColumns(ctrl) {
  return [
    {
      label: 'Name',
      cellClass: 'tl',
      render: function (user) {
        return renderMemberNameCell(ctrl, user);
      }
    },
    {
      label: 'Email',
      cellClass: 'tl',
      render: function (user) { return user.email; }
    },
    {
      label: 'Phone',
      cellClass: 'tl',
      render: function (user) { return user.sms; }
    },
    {
      label: 'Group Admin',
      cellClass: 'tl',
      render: renderAdminIcon
    }
  ];
}

function ensurePermissionGroup(edge, ctrl) {
  edge.in = { '@rid': ctrl.group['@rid'], name: ctrl.group.name };
  return edge;
}

function ensureSimplePermissionRecord(edge, ctrl, label) {
  ensurePermissionGroup(edge, ctrl);
  edge.dashboard = edge.out && edge.out['@rid'];
  edge.group = edge.in;
  edge.customModalTitle = 'Edit ' + label + ' Permission - ' + ctrl.group.name;
  return edge;
}

function editPermissionScope(ctrl, edge) {
  var klass = edge && edge.out && edge.out['@class'];

  if (klass === 'Dashboard') {
    dashboardPermissionModal.editDialogue(ensureSimplePermissionRecord(edge, ctrl, 'Dashboard'), { submitCallback: ctrl.init });
    return;
  }

  if (klass === 'ReportFolder') {
    reportFolderPermissionModal.editDialogue(ensureSimplePermissionRecord(edge, ctrl, 'Report Folder'), { submitCallback: ctrl.init });
    return;
  }

  groupPermissionModal.editDialogue(ensurePermissionGroup(edge, ctrl), { submitCallback: ctrl.init });
}

function deletePermissionScope(ctrl, edge) {
  groupPermissionModal.deleteDialogue(ensurePermissionGroup(edge, ctrl), { dashboardCallback: ctrl.init });
}

function permissionActionItems(ctrl, edge) {
  var items = [];

  if (ctrl.isGroupAdmin) {
    items.push({
      label: 'Edit Scope',
      icon: 'ion-ios-compose',
      onclick: function () { editPermissionScope(ctrl, edge); }
    });
  }

  if (ctrl.canEditAccessPermissions) {
    items.push({
      label: 'Delete Permission',
      icon: 'ion-ios-trash',
      class: 'red',
      onclick: function () { deletePermissionScope(ctrl, edge); }
    });
  }

  return items;
}

function renderPermissionPathCell(ctrl, edge, renderPath) {
  var actions = permissionActionItems(ctrl, edge);

  return m('div.flex.items-center.justify-between', [
    m('span.mr3.flex-auto', { style: { minWidth: 0, maxWidth: '100%', overflow: 'hidden' } }, renderPath(edge)),
    actions.length ?
      m('span.flex-none', [
        m(rowActionDropdown, {
          buttonClass: 'dib mr3',
          items: actions
        })
      ])
      :
      ''
  ]);
}


var groupDetail = {};

groupDetail.oninit = function () {
  var ctrl = this;
  header.vm.activeTab('Groups');
  document.title = 'nimrod | Groups';
  ctrl.groupRid = m.route.param('id');
  ctrl.requestStatus = prop(RequestStatus.PENDING);
  ctrl.requestStatusCode = prop();
  ctrl.identityMode = prop('local');
  ctrl.memberActionError = prop('');
  ctrl.retryMemberAction = null;
  ctrl.init = function () {
    ctrl.groupRid = m.route.param('id');
    ctrl.group = undefined;
    ctrl.requestStatus(RequestStatus.PENDING);
    ctrl.requestStatusCode();
    return Promise.all([
      ensureRoomClassTreeLoaded(),
      loaders.requestWithLoader({
        url: `/api/v1/group/${ctrl.groupRid}`,
        method: "GET"
      }),
      loaders.requestWithLoader({
        url: '/api/v1/user/identity-mode',
        method: 'GET'
      }).catch(function () { return { mode: 'local' }; })
    ]).then(function (results) {
      var result = results[1];
      ctrl.identityMode(results[2].mode === 'entra' ? 'entra' : 'local');
      (result.members || []).forEach(r => r.name = r.firstName + ' ' + r.lastName);
      (result.members || []).sort((a, b) => a.name.localeCompare(b.name));
      ctrl.group = result;
      ctrl.groupAdminMemberRids = (ctrl.group.members || []).filter(r => r.isGroupAdmin).map(r => r['@rid'])
      ctrl.canEditAccessPermissions = session.user().isSuperuser == true || session.user().isSuperuser == 1;
      ctrl.isGroupAdmin = ctrl.canEditAccessPermissions || ctrl.groupAdminMemberRids.includes(session.user()['@rid']);
      ctrl.requestStatus(RequestStatus.SUCCESS);
      m.redraw();
    }).catch(function (error) {
      ctrl.requestStatusCode(error && (error.status || error.code || (error.response && error.response.status)));
      ctrl.requestStatus(RequestStatus.ERROR);
      m.redraw();
      return null;
    })
  };

  ctrl.runMemberAction = function (request) {
    ctrl.memberActionError('');
    ctrl.retryMemberAction = function () {
      return ctrl.runMemberAction(request);
    };
    return loaders.requestWithLoader(request)
      .then(function () {
        return ctrl.init();
      })
      .catch(function (error) {
        console.error('Unable to update group membership:', error);
        ctrl.memberActionError('Unable to update group membership. Please try again.');
        m.redraw();
        // Dropdown actions do not consume returned promises, so a handled
        // result here prevents an unhandled browser rejection.
        return null;
      });
  };

  ctrl.updateIsAdmingroup = function (record, value) {
    return ctrl.runMemberAction({
      url: `/api/v1/groupadmin/${record.out_MemberRid.slice(1)}`,
      method: "PUT",
      body: {
        isGroupAdmin: value,
        groupRid: ctrl.group['@rid'].slice(1)
      },
    });
  };

  ctrl.deleteUserFromGroup = function (record) {
    return ctrl.runMemberAction({
      url: `/api/v1/useringroup/${record.out_MemberRid.slice(1)}`,
      method: "DELETE",
    });
  };


  return ctrl.init();
};

groupDetail.onupdate = function () {
  var ctrl = this;
  if (ctrl.groupRid !== m.route.param('id')) {
    ctrl.init();
  }
}

groupDetail.onremove = function () {
}

groupDetail.view = function () {
  var ctrl = this;
  if (ctrl.requestStatus() !== RequestStatus.SUCCESS || !ctrl.group) {
    return m(requestStatusHandler, {
      requestStatus: ctrl.requestStatus,
      requestStatusCode: ctrl.requestStatusCode,
      onRetry: ctrl.init,
    });
  }
  return m('div.mh3.mb5', [
    m('div.v-btm.bb.b--mid-gray.bw1.f-subheadline.mb3.pb2.display.mb3.flex.justify-between.items-center', [
      m('div', [
        m('div.mr2.dib-ns', [
          m(m.route.Link, { href: '/groups' }, 'Groups'),
          ' / ',
          m('div.mr2.dib-ns', ctrl.group.name)
        ])
      ]),
      ctrl.isGroupAdmin ?
        m(buttonElement, {
          label: 'Edit Group',
          func: () => {
            groupModal.editDialogue(ctrl.group, { delete: true, submitCallback: ctrl.init, dashboardCallback: function () { m.route.set('/groups'); } });

          }
        })
        : ''
    ]),
    ctrl.memberActionError() ?
      m('div.red.ba.b--red.pa2.mb3', { role: 'alert' }, [
        m('span', ctrl.memberActionError()),
        ctrl.retryMemberAction ?
          m('button.ml3', {
            type: 'button',
            onclick: ctrl.retryMemberAction
          }, 'Retry')
          :
          ''
      ])
      :
      '',
    renderGroupDetailTable({
      title: renderTableTitle('Users', (ctrl.group.members || []).length),
      columns: memberColumns(ctrl),
      rows: ctrl.group.members || [],
      emptyText: 'No users found for this group.'
    }),
    function permissionsTable() {
      const allPermissions = (ctrl.group.permissions || []);

      // Build a simplified permission scope string
      const buildScopeString = (edge) => {
        const isTrue = (v) => v === 1 || v === true || v === '1';
        const hasAllRead = isTrue(edge.read);
        const hasAllWrite = isTrue(edge.write);
        if (hasAllRead || hasAllWrite) {
          const parts = [];
          if (hasAllRead) parts.push('R');
          if (hasAllWrite) parts.push('W');
          return `All (${parts.join(' + ')})`;
        }
        let readCount = 0;
        let writeCount = 0;
        Object.keys(edge || {}).forEach((key) => {
          if (['out', 'in', '@rid', '@class'].includes(key)) return;
          if (key.startsWith('parent')) return;
          const val = edge[key];
          if (!isTrue(val)) return;
          if (key.endsWith('Read')) readCount++;
          if (key.endsWith('Write')) writeCount++;
        });
        if (readCount === 0 && writeCount === 0) return 'No access';
        return `Read: ${readCount}, Write: ${writeCount}`;
      };

      // Compute link and type
      const linkFor = (edge) => {
        const out = edge.out || {};
        const rid = (out['@rid'] || '').toString();
        const id = rid.startsWith('#') ? rid.slice(1) : rid;
        const klass = (out['@class'] || '').toString();
        if (klass === 'Dashboard') {
          return { href: '/dashboard/' + id, type: 'Dashboard' };
        } else if (klass === 'ReportFolder') {
          return { href: '/reportfolder/' + id, type: 'Report Folder' };
        } else if (isLocationClass(klass)) {
          return { href: '/location/' + id, type: 'Location' };
        } else {
          return { href: `/equipment/${klass.toLowerCase()}/${id}`, type: 'Equipment' };
        }
      };

      const labelForPath = (edge) => {
        const out = edge.out || {};
        const pathArr = Array.isArray(out.path) ? out.path : [];
        const nodes = pathArr.filter(n => !(n && n.name === 'root' && n['@class'] === 'Dashboard'));
        if (!nodes.length) return (out.name || out['@class'] || '').toString();
        const toLabel = (node) => {
          const klass = (node['@class'] || '').toString();
          if (node.name === 'root') return 'Home';
          if (isRoomClass(klass)) return `${node.name} ${node.roomNumber || ''}`.trim();
          return node.name || klass;
        };
        return nodes.map(toLabel).join(' / ');
      };

      const dataToShow = allPermissions
        .sort((a, b) => naturalCompareStrings(labelForPath(a), labelForPath(b)));

      const renderPath = (edge) => {
        const out = edge.out || {};
        const { href } = linkFor(edge);
        const pathArr = Array.isArray(out.path) ? out.path : [];
        const nodes = pathArr.filter(n => !(n && n.name === 'root' && n['@class'] === 'Dashboard'));

        if (!nodes.length) {
          const label = out.name || out['@class'] || href;
          return m(m.route.Link, {
            href,
            class: 'smart-table-path-last',
            title: label
          }, [
            m('span', { style: { direction: 'ltr' } }, label)
          ]);
        }

        const pathLabel = nodes.map(function (node) {
          const klass = (node['@class'] || '').toString();
          if (node.name === 'root') return 'Home';
          if (isRoomClass(klass)) return `${node.name} ${node.roomNumber || ''}`.trim();
          return node.name || klass;
        }).join(' / ');

        return m('span.smart-table-path-last', { title: pathLabel }, [
          m('span', { style: { direction: 'ltr' } }, nodes.map((node, idx) => {
          const klass = (node['@class'] || '').toString();
          const ridStr = (node['@rid'] || '').toString();
          const id = ridStr.startsWith('#') ? ridStr.slice(1) : ridStr;
          const isLocation = isLocationClass(klass);
          const label = node.name === 'root'
            ? 'Home'
            : isRoomClass(klass)
              ? `${node.name} ${node.roomNumber || ''}`.trim()
              : (node.name || klass);
          const nodeHref =
            klass === 'Dashboard' ? `/dashboard/${id}` :
              klass === 'ReportFolder' ? `/reportfolder/${id}` :
              isLocation ? `/location/${id}` :
                `/equipment/${klass.toLowerCase()}/${id}`;
          return [
            m(m.route.Link, { class: 'mr1', href: nodeHref }, label),
            idx < nodes.length - 1 ? m('span.mr1', '/') : ''
          ];
        }))
        ]);
      };

      const renderScope = (edge) => {
        const scopeLabel = buildScopeString(edge);
        return m('span', scopeLabel || '—');
      };

      return renderGroupDetailTable({
        title: renderTableTitle('Access Permissions', allPermissions.length),
        columns: [
          {
            label: 'Path',
            cellClass: 'tl',
            render: function (edge) {
              return renderPermissionPathCell(ctrl, edge, renderPath);
            }
          },
          {
            label: 'Scope',
            cellClass: 'tl',
            render: renderScope
          },
          {
            label: 'Type',
            cellClass: 'tl nowrap',
            render: function (edge) { return linkFor(edge).type; }
          }
        ],
        rows: dataToShow,
        emptyText: 'No permissions found for this group.'
      });

    }(),
    ctrl.isGroupAdmin ?
      m('div.mt4', [
        m(buttonElement, {
          label: 'Edit Members',
          class: 'fr ',
          func: addMemberModal.editDialogue.bind(addMemberModal, ctrl.group, { submitCallback: ctrl.init })
        }),
        ctrl.identityMode() === 'entra'
          ? m('p.fr.mr2.gray', 'Invite users from the Users page before adding them to this group.')
          : m(buttonElement, {
            label: 'Create New User',
            class: 'fr mr2',
            func: userModal.editDialogue.bind(userModal, {}, { groupRecord: ctrl.group, submitCallback: ctrl.init })
          })
      ])
      : '',
  ]);

};


module.exports = groupDetail;
